import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Input from "@mui/material/Input";
import { IPromptEntry } from "./IPromptEntry";
import { useStyles } from "./promptEntryStyles";
import StaticHeadline from "../StaticHeadline/StaticHeadline";
import StaticCard from "../StaticCard/StaticCard";
import { constants } from "../../constants";

const PromptEntry = ({ variant, handleSubmitPrompt }: IPromptEntry) => {
    const { classes } = useStyles({ variant });
    const [inputValue, setInputValue] = useState("");

    useEffect(() => {
        handleSubmitPrompt(inputValue);
    }, [inputValue, handleSubmitPrompt]);
    return (
        <Box data-name="PromptEntry" className={classes.root}>
            {variant === "end-page" && (
                <>
                    <StaticHeadline
                        variant="entry-point"
                        headline={constants.copy.endPagePrompt.headline}
                        subHeadline={constants.copy.endPagePrompt.subHeadline}
                    />
                    <Box className={classes.cardContainer}>
                        <StaticCard
                            message="Gold Watches"
                            backgroundImage="./assets/img/proposalbg_1.png"
                            onClick={() => {
                                handleSubmitPrompt("Gold Watches");
                            }}
                        />
                        <StaticCard
                            message="Black Watches"
                            backgroundImage="./assets/img/proposalbg_2.png"
                            onClick={() => {
                                handleSubmitPrompt("Black Watches");
                            }}
                        />
                        <StaticCard
                            message="Novel Watches"
                            backgroundImage="./assets/img/proposalbg_3.png"
                            onClick={() => {
                                handleSubmitPrompt("Novel Watches");
                            }}
                        />
                    </Box>
                </>
            )}
            {variant === "entry-point" && (
                <Box className={classes.entryPoint}>
                    <span className={classes.eyebrow}>
                        {constants.copy.entryPoint.eyebrow}
                    </span>
                    <Input
                        className={classes.input}
                        id="font-size"
                        placeholder={constants.copy.prompt.inputPlaceholder}
                        disableUnderline={true}
                        onChange={(e) => {
                            setInputValue(e.target.value);
                        }}
                        onClick={() => {}}
                        onKeyDown={() => {}}
                        value={inputValue}
                    />
                </Box>
            )}
        </Box>
    );
};

export default PromptEntry;
